import React from 'react'
import { Toa } from './Toa'
import './ToaPage.scss'

export const ToaPage = () => (
  <div className='row'>
    <Toa />
  </div>
)
